import IUserMenu from '../interfaces/IUserMenu';
import hasPermission from './role-based-access/hasPermission';

const hasMenuPermission = (menu: IUserMenu, rolePermissions: string[] = []): boolean => {
  if (!menu) return false;
  if (!menu.permissions || menu.permissions.length === 0) {
    return true;
  }
  return menu.permissions.every(
    perm => !perm || !perm.isRequired || hasPermission(perm.permission, rolePermissions),
  );
};

export default hasMenuPermission;
